import { render, staticRenderFns } from "./categoryMainList.vue?vue&type=template&id=521c6c3f&"
import script from "./categoryMainList.vue?vue&type=script&lang=js&"
export * from "./categoryMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports